<app-image [size]="size" [src]="organization[theme].logoURL"></app-image>
